import styled from "@emotion/styled";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { paths } from "setup/PageRouter/routesConfig";
import { numberFormatInt } from "utils/nuberFormat";
import { useSellerFinanceSummary } from "hooks/useSellerReport";
import SectionCard from "../shared/SectionCard";
import { sd } from "../tokens";

/** การ์ด "รอบรับเงิน" — ยอดสด ไม่ผูกกับช่วงเวลาที่เลือกด้านบน */
const PayoutCard = () => {
  const navigate = useNavigate();
  const { data, isPending, isFetching, isError, refetch } = useSellerFinanceSummary();

  return (
    <SectionCard
      eyebrow="การเงิน"
      title="รอบรับเงิน"
      minHeight={280}
      skeletonRows={4}
      loading={isPending}
      refreshing={isFetching && !isPending}
      error={isError ? true : undefined}
      onRetry={() => refetch()}
    >
      <Layout>
        <Tile>
          <TileLabel>ถอนได้แล้ว</TileLabel>
          <TileValue>฿{numberFormatInt(data?.withdrawable_amount ?? 0)}</TileValue>
          <TileSub>{numberFormatInt(data?.withdrawable_order_count ?? 0)} คำสั่งซื้อ</TileSub>
        </Tile>
        <OrangeButton block type="primary" onClick={() => navigate(paths.manageFinance)}>
          ไปหน้าถอนเงิน
        </OrangeButton>
      </Layout>
    </SectionCard>
  );
};

export default PayoutCard;

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 12px;
`;

const Tile = styled.div`
  flex: 1;
  border-radius: 10px;
  padding: 18px;
  background: linear-gradient(135deg, ${sd.blue} 0%, #3d92e0 100%);
  color: #fff;
`;

const TileLabel = styled.div`
  font-size: 13px;
  opacity: 0.9;
`;

const TileValue = styled.div`
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  word-break: break-all;
`;

const TileSub = styled.div`
  font-size: 12px;
  opacity: 0.9;
`;

/* colorPrimary ของทั้งระบบเป็นน้ำเงิน — ปุ่มส้มของ mockup จึง override เฉพาะปุ่มนี้ */
const OrangeButton = styled(Button)`
  background: ${sd.orange};
  border-color: ${sd.orange};

  &:hover,
  &:focus {
    background: #e07717 !important;
    border-color: #e07717 !important;
  }
`;
